import React, { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import TabBar from 'components/common/TabBar';
import BookContent from './components/BookContent';
import ClassroomBooksContent from './components/ClassroomBooksContent';
import ClassroomBooksTabHeading from './components/ClassroomBooksTabHeading';
import LetterBooksContent from './components/LetterBooksContent';
import LetterBooksTabHeading from './components/LetterBooksTabHeading';

import { BookType } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import { AppRoutes } from 'types';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const t = (key: string, options?) => translate('letterBooks', key, options);

const LetterBooks: React.FC<any> = () => {
  const location = useLocation();
  const params = useParams();
  const title = location.state?.title;
  const bookCode = params.bookCode;
  const letter = bookCode ? bookCode[bookCode.length - 1] : undefined;
  const isLetterBookPage = location.pathname.includes(AppRoutes.LETTER_BOOKS);
  const omitRoutes = useTrialUserOmitRoutes();
  const tabList: Array<{ Component: React.FC }> = useMemo(
    () => [{ Component: LetterBooksTabHeading }, { Component: ClassroomBooksTabHeading }],
    []
  );

  const tabComponentList: Array<{ Component: React.FC }> = useMemo(
    () => [{ Component: LetterBooksContent }, { Component: ClassroomBooksContent }],
    []
  );
  return bookCode ? (
    <BookContent
      bookCode={bookCode}
      bookTitle={title}
      bookType={isLetterBookPage ? BookType.LETTER_BOOK : BookType.CLASSROOM_BOOK}
      letter={isLetterBookPage ? letter : undefined}
      backRoute={isLetterBookPage ? `/${AppRoutes.LETTER_BOOKS}` : `/${AppRoutes.CLASSROOM_BOOKS}`}
    />
  ) : (
    <>
      <SectionHeader omitRoutes={omitRoutes} title={t('letterBooks')} />
      <TabBar
        tabs={tabList}
        tabViews={tabComponentList}
        defaultTabIndex={isLetterBookPage ? 0 : 1}
        handleStateChange={true}
      />
    </>
  );
};

export default LetterBooks;
